import { useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import { useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '@/lib/store/useAuthStore'
import { usePickIntentStore } from '@/lib/store/usePickIntentStore'
import { keys } from '../keys'

export function useGlobalPicksSync() {
    const queryClient = useQueryClient()
    const { user } = useAuthStore()

    useEffect(() => {
        if (!user?.id) return

        let timeoutId: ReturnType<typeof setTimeout>

        const channel = supabase.channel('global-picks-sync')
            .on(
                'postgres_changes',
                {
                    event: '*', // Listen to INSERT, UPDATE, DELETE
                    schema: 'public',
                    table: 'picks',
                    filter: `user_id=eq.${user.id}`
                },
                (payload) => {
                    // Debounce invalidation by 1500ms to prevent rapid re-fetches
                    // protecting against massive batch imports or heavy webhook activity.
                    clearTimeout(timeoutId)
                    timeoutId = setTimeout(() => {
                        if (usePickIntentStore.getState().isSavingPick) {
                            console.log('[SYNC] Mutation in progress. Skipping realtime sync to preserve optimistic UI.')
                            return
                        }
                        console.log('[SYNC] Realtime update received for picks, invalidating queries...', payload)
                        queryClient.invalidateQueries({ queryKey: keys.picks.all() })
                    }, 1500)
                }
            )
            .subscribe()

        return () => {
            clearTimeout(timeoutId)
            supabase.removeChannel(channel)
        }
    }, [user?.id, queryClient])
}
